module.exports = __webpack_public_path__ + "static/img/infectious-disease_icon-16.93c7d60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vaccinetest/infectious-disease_icon-16.png
// module id = f+B9
// module chunks = 0